/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the status of a review message. All new messages are Created at first, then they can be updated.
 */
export const ReviewMessageStatus = {
    Created: 1,
    Opened: 2
} as const;
export type ReviewMessageStatus = typeof ReviewMessageStatus[keyof typeof ReviewMessageStatus];

